// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
export function createDrawerContext() {
    return React.createContext({
        show: false,
        toggle: function () { },
        testSelector: undefined,
    });
}
